import Container from '../../components/layout/Container'
import PrivateRoute from '../../auth/private-route'
import { useAuth } from 'react-oidc-context'
import { useHistory } from 'react-router-dom';

export default function Login(props) {
    const auth = useAuth()

    const history = useHistory();
    
    if (auth.isAuthenticated) {
        history.push('/Dashboard');
    }

    return (
        <PrivateRoute rolesAllowed={props.roles}>
            <Container title="Login">
            </Container >
        </PrivateRoute>
    )
}